import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapse"
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    this.contentTargets.forEach(el => el.classList.toggle("hidden"))

    // Rotate the icon (chevron down becomes chevron up)
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }
}
